import React, { useState, useEffect } from 'react';
import styles from './Otp.scss';
import Input from '../Input/Input';
import Button from '../Button/Button';
import Spinner from '../Spinner/Spinner';
import { checkOneField } from '../validation';
import { get, isEmpty, isUndefined } from 'lodash';
import classNames from 'classnames';
import { pluralize } from 'numeralize-ru';

const OTP = props => {

  const [userNumber, setUserNumber] = useState('');
  const [timerId, setTimerId] = useState({ resendOtpTimer: null, blockedForTimer: null });
  const [remainingTime, setRemainingTime] = useState({ resendOtp: null, blockedFor: null });
  const [otpCode, setOtpCode] = useState('');
  const [otpCodeErr, setOtpCodeErr] = useState('');
  const [params] = useState(props.params);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOTPForwarded, setIsOTPForwarded] = useState(false);
  const [isOTPInfoOpened, setIsOTPInfoOpened] = useState(false);
  const [isOTPInfoVisible, setIsOTPInfoVisible] = useState(false);
  const [isOTPInfoBtnVisible, setIsOTPInfoBtnVisible] = useState(false);

  const [paramsTimer, setFirstParam] = useState({});

  useEffect(() => {
    const msisdn = get(params, 'msisdn', '');
    setUserNumber(msisdn.replace(/(\d{3})(\d{5})(\d{2})/, '+7 ($1) ***-**-$3'));
    const nextOtpPeriod = get(params, 'nextOtpCodePeriod', 0);
    nextOtpPeriod > 0 && setTimer('resendOtpTimer', 'resendOtp');
    setRemainingTime({ ...remainingTime, resendOtp: nextOtpPeriod });
  }, []);

  useEffect(() => !checkOtpCode() && sendOTP(), [otpCode]);

  useEffect(() => {
    if (remainingTime.resendOtp === 0) {
      clearInterval(timerId.resendOtpTimer);
      setTimerId({ ...timerId, resendOtpTimer: undefined });
    }
    if (remainingTime.blockedFor === 0) {
      clearInterval(timerId.blockedForTimer);
      setTimerId({ ...timerId, blockedForTimer: undefined });
      setOtpCodeErr('');
    }
  }, [remainingTime])

  useEffect(() => {
    if (Object.keys(paramsTimer).length !== 0) {
      const newTimer = setInterval(() => {
        remainingTime[paramsTimer.prop] > 0 && setRemainingTime({
          ...remainingTime,
          [paramsTimer.prop]: remainingTime[paramsTimer.prop] - 1
        });
        remainingTime[paramsTimer.prop] === 0 && paramsTimer.prop === 'resendOtp' && setIsOTPForwarded(false);
      }, 1000);

      setTimerId({ ...timerId, [paramsTimer.id]: newTimer });
      return () => clearInterval(newTimer)
    }
  }, [remainingTime])

  useEffect(() => {
    const error = get(props, 'params.errors_text');
    if (error === 'otp_expired<br>') {
      setIsDisabled(true);
      setOtpCode('');
      setOtpCodeErr('Срок действия кода истёк. Запросите новый.');
    }
    if (error === 'invalid_otp<br>') {
      const nextOtpPeriod = get(props, 'params.nextOtpCodePeriod', 0);
      isUndefined(timerId.resendOtpTimer) && nextOtpPeriod > 0 && setTimer('resendOtpTimer', 'resendOtp');
      const message = `Неверный код. Осталось ${get(props, 'params.otpCodeAvailableAttempts')} ${pluralize(get(props, 'params.otpCodeAvailableAttempts'), 'попытка', 'попытки', 'попыток')}`;
      setRemainingTime({ ...remainingTime, resendOtp: nextOtpPeriod });
      setOtpCode('');
      setOtpCodeErr(message);
    }
    if (error === 'too_many_wrong_code') {
      isUndefined(timerId.blockedForTimer) && setTimer('blockedForTimer', 'blockedFor');
      setIsDisabled(true);
      setRemainingTime({ ...remainingTime, blockedFor: get(props, 'params.blockedFor', 0) });
      setOtpCode('');
      setOtpCodeErr('Попытки исчерпаны. Запросите новый код.');
    }
  }, [props]);

  const setTimer = (id, prop) => {
    setFirstParam({ id, prop });
  }

  const handleChange = (event) => {
    const { value } = event.target;
    setOtpCodeErr('');
    setOtpCode(value);
  }

  const checkOtpCode = () => {
    const otpCodeError = checkOneField(otpCode, 'otpCode');
    return isEmpty(otpCode) || !isEmpty(otpCodeError);
  }

  const sendOTP = () => {
    setIsLoading(true);
    apiAdapter.sendForm({ otpCode }, data => {
      if (get(data, 'component', '') !== '') {
        props.route(data.component, data.params);
        setIsLoading(false);
      }
    }, 'validate');
  }

  const resendOTP = () => {
    setIsLoading(true);
    apiAdapter.sendForm({}, data => {
      if (get(data, 'component', '') !== '') {
        props.route(data.component, data.params);
        setIsLoading(false);
        setIsOTPForwarded(true);
        setIsOTPInfoBtnVisible(true);
        setIsDisabled(false);
      }
    }, 'send');
    const nextOtpCodePeriod = get(props, 'params.nextOtpCodePeriod', 60);
    setRemainingTime({ ...remainingTime, resendOtp: nextOtpCodePeriod });
  }

  const toggleOTPInfo = () => {
    setIsOTPInfoOpened(!isOTPInfoOpened);
    setTimeout(() => setWidgetHeight(), 100);
  }

  const setWidgetHeight = () => {
    const widget = document.getElementById('widget0');
    const widgetHeight = widget.offsetHeight;
    const widgetWidth = widget.offsetWidth;
    const target = apiAdapter.url.replace('sso/auth/login-widget-router', '') !== 'https://i.zenit.ru' ? '*' : apiAdapter.url;
    window.top.postMessage(JSON.stringify({
      comrooxteampubsubid: 'com.rooxteam.login.adjustHeight',
      args: [widgetHeight, widgetWidth]
    }), target);
    setIsOTPInfoVisible(!isOTPInfoVisible);
  }

  const isMobile = document.documentElement.clientWidth < 480;

  return (
    <div className={styles.Main}>
      <div className={styles.WrapperHeader}>
        <div className={styles.Title}>Подтверждение</div>
      </div>
      <div className={styles.Text}>Введите код, отправленный на номер <br/>{userNumber}</div>
      <Input
        name='otpCode'
        label="Код подтверждения"
        onChange={handleChange}
        value={otpCode}
        mask="9999"
        maskChar={null}
        error={otpCodeErr}
        id='codeConfirmation'
        disabled={isLoading || timerId.blockedForTimer || isDisabled}
        disabledInputStyle={isLoading || timerId.blockedForTimer || isDisabled}
        autofocus={!isMobile}
        adaptiveIframe={true}
      />
      {!timerId.blockedForTimer &&
      <div className={isLoading ? styles.FlexRight : styles.Wrapper}>
        {isLoading &&
        <div className={styles.Circle}>
          <Spinner
            className={classNames(styles.MainSpinner, styles.WhiteColor)}
            IEStyle={styles.IESpinner}
          />
        </div>
        }
        {!isLoading && !isOTPForwarded &&
        <Button
          data-test-id="sendAgain"
          transparent
          onClick={resendOTP}
          className={styles.LinkAuth}
        >
          Отправить ещё раз
        </Button>
        }
        {isOTPForwarded && timerId.resendOtpTimer && !isLoading &&
        <div className={styles.Message}>
          Код отправлен, повторно<br/>отправить через {remainingTime.resendOtp} секунд
        </div>
        }
        {isOTPInfoBtnVisible && !isLoading &&
        <Button
          data-test-id="codeNotCome"
          transparent
          onClick={toggleOTPInfo}
          className={styles.LinkAuth}
        >
          Не приходит код?
        </Button>
        }
      </div>
      }
      {timerId.blockedForTimer &&
      <div className={styles.Message}>
        Отправить повторно через {remainingTime.blockedFor} секунд
      </div>
      }
      {isOTPInfoOpened &&
      <div className={classNames(styles.List, isOTPInfoVisible ? styles.Visible : '')}>
        <p>1. Проверьте, не включен ли у вас на телефоне «Авиарежим» или режим «Не беспокоить»</p>
        <p>2. Возможно, вы не предоставили в банк новый номер мобильного телефона, и мы отправили код на старый.
          Позвоните в банк по бесплатному номеру <br/>8-800-500-66-77 </p>
        <p>3. Проблемы могут быть со стороны вашего сотового оператора. Обратитесь в их службу поддержки. </p>
      </div>
      }
    </div>
  );
}

export default OTP;
